import MenuItem from './MenuItem';
import style from './index.module.scss';

const Navigation = (props) => {
  const { config } = props;
  const { company, enterprise, product } = config;

  return (
    <ul className={style.navigation}>
      <MenuItem
        submenuMaxHeight={216}
        name={'Product'}
        submenu={product}
        position={'left'}
      />
      <MenuItem
        submenuMaxHeight={216}
        name={'Enterprise'}
        submenu={enterprise}
        position={'left'}
      />
      <MenuItem name={'Pricing'} to={'/pricing'} />
      <MenuItem name={'Company'} submenu={company} position={'center'} />
      <MenuItem name={'Support'} to={'/help-center'} />
    </ul>
  );
};

export default Navigation;
